<template>
  <div>
    <div class="d-flex align-items-center mb-4">
      <img src="../assets/images/user.svg" class="mr-3" style="width: 50px; height: 50px" alt="" />
      <div>
        <h4>免費註冊會員</h4>
        <h6>看展更快速，產業訊息更流通</h6>
      </div>
    </div>
    <p>快速獲得展覽最新消息、活動索票資訊、專屬展昭會員優惠及權利，並可免費訂閱會員電子報及展覽資訊報。</p>
    <a href="https://www.chanchao.com.tw/accounts/signup" class="btn btn-block btn-secondary mt-3">立即註冊</a>

    <!-- <router-link class="btn btn-block btn-secondary mt-3" to="/signup">立即註冊</router-link> -->

    <hr />

    <h4 class="my-4">常見問題</h4>

    <ul class="ml-0 pl-4">
      <li>
        <a href="//www.chanchao.com.tw/downloads/%E6%9C%83%E5%93%A1%E8%A8%BB%E5%86%8A%E7%AF%87.pdf" target="_blank"
          >如何加入會員?</a
        >
      </li>
      <li>
        <a
          href="//www.chanchao.com.tw/downloads/04%E9%82%80%E8%AB%8B%E4%BB%A3%E7%A2%BC%E7%B4%A2%E7%A5%A8.pdf"
          target="_blank"
          >如何索票? 何謂邀請代碼入場?</a
        >
      </li>
      <li>
        <a
          href="//www.chanchao.com.tw/downloads/03%E5%BF%AB%E9%80%9F%E5%85%A5%E5%A0%B4%E7%AF%87(%E6%89%8B%E6%A9%9F%E7%89%88).pdf"
          target="_blank"
          >如何快速掃描入場?</a
        >
      </li>
    </ul>

    <div class="d-flex mt-3">
      <a href="//www.chanchao.com.tw/qa.asp" target="_blank"
        >更多常見問題<i class="fas fa-external-link-alt ml-2"></i
      ></a>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },

    methods: {},

    created() {},
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
